import { ReactNode } from 'react';

import {
  HexIcon,
  Icons,
  withProps,
  Typography,
  Stack,
  tokens,
} from '@cast/design-system';

type Props = {
  variant: 'success' | 'error';
  title: ReactNode;
  subTitle?: ReactNode;
  body?: ReactNode;
};

export const DialogFeedbackMessage = ({
  variant,
  title,
  subTitle,
  body,
}: Props) => {
  const Icon =
    variant === 'success'
      ? withProps(HexIcon, {
          variant: 'success' as const,
          icon: <Icons.Check />,
        })
      : withProps(HexIcon, { variant: 'error' as const });

  return (
    <Stack display="grid" gridTemplateColumns="36px auto" gap={8}>
      <Stack>
        <Icon size={36} />
      </Stack>
      <Stack>
        <Typography
          variant="h5"
          mt={4}
          mb={6}
          color={tokens.theme.fg.structural.primary}
        >
          {title}
        </Typography>
        {subTitle && (
          <Typography
            variant="P12B"
            mb={16}
            color={tokens.theme.fg.structural.primary}
            component="div"
          >
            {subTitle}
          </Typography>
        )}
        {body && (
          <Typography
            variant="P12R"
            color={tokens.theme.fg.structural.secondary}
            component="div"
          >
            {body}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};
